<template>
    <div class="w-full lg:w-1/2 border p-4 rounded-lg">
        <div class="flex justify-between">
            <h4 class="text-lg">Enter Vehicle Details</h4>
            <button @click="$emit('remove')" v-if="isLast" type="button" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                <span class="sr-only">Close</span>
                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
        <TextInput
            label="Registration number"
            v-model="modelValue.registration"
            styling="uppercase"
            :validation="v$.modelValue.registration"
        ></TextInput>
        <div class="block">
            <div class="items-center block md:inline-block mt-4" v-for="(vehicleType, key) in filteredTypes" :key="key">
                <label>
                    <input
                        type="radio"
                        class="focus:ring-transparent h-4 w-4 mr-1 border-gray-300 text-ap-fs-primary"
                        v-model="modelValue.type"
                        :value="key"
                        @change="updatePrice(key, vehicleType.adjusted)"
                    >
                    <span class="mr-4 text-sm font-light text-gray-700 capitalize">
                        {{ key }} - {{ $filters.money(vehicleType.adjusted) }}
                    </span>
                </label>
            </div>
        </div>
        <div class="mt-3">
            <TextInput
                label="Party size"
                type="number"
                v-model.number="modelValue.partySize"
                :validation="v$.modelValue.partySize"
            ></TextInput>
        </div>
        <div v-if="modelValue.type" class="mt-2">
            <label class="block text-sm font-medium text-gray-700">Valets</label>
            <select v-model="modelValue.valet" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
                <option :value="null">No Valet</option>
                <option v-for="valet in filteredValets" :key="valet.id" :value="valet">{{ valet.name }} - {{ $filters.money(valet.price) }}</option>
            </select>
            <a href="/valets" target="_blank" class="underline text-gray-600 text-sm normal-case">About our valets</a>
        </div>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { helpers, minValue, numeric, required } from '@vuelidate/validators';
import TextInput from '../TextInput.vue';

const { withMessage } = helpers;

export default {
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            mounted: false,
        };
    },
    validations() {
        return {
            modelValue: {
                registration: {
                    required: withMessage('Vehicle registration is required', required),
                },
                type: {
                    required: withMessage('Vehicle type is required', required),
                },
                partySize: {
                    required: withMessage('Party Size is required', required),
                    numeric: withMessage('Party size must be a number', numeric),
                    minValue: minValue(1),
                },
                price: {
                    required: withMessage('Price is required', required),
                },
            },
        };
    },
    props: {
        modelValue: { required: true },
        types: { required: true },
        isLast: { type: Boolean },
        product: { required: true },
        valet: { required: true },
    },
    computed: {
        filteredTypes() {
            return this.types[this.product.id] || {};
        },
        filteredValets() {
            if (!this.valet) return [];
            const vehicleType = this.valet.find(v => v.name.toLowerCase() === this.modelValue.type.toLowerCase());
            return vehicleType ? vehicleType.valets : [];
        }
    },
    watch: {
        modelValue: {
            deep: true,
            immediate: false,
            handler(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
    methods: {
        selectedVehicleType(type) {
            this.modelValue.type = type;
            this.updatePrice(this.filteredTypes[type].adjusted);
        },
        updatePrice(type, price) {
            this.modelValue.type  = type;
            this.modelValue.price = price;
        }
    },
    mounted() {
        if (!this.modelValue?.type) {
            const defaultType = Object.keys(this.filteredTypes)[0];
            const defaultPrice = this.filteredTypes[defaultType].adjusted;
            this.modelValue.type = defaultType;
            this.modelValue.price = defaultPrice;
            this.$emit('update:modelValue', this.modelValue);
        } else if (!this.modelValue.price) {
            this.modelValue.price = this.filteredTypes[this.modelValue.type].adjusted;
            this.$emit('update:modelValue', this.modelValue);
        }
    },
    components: {
        TextInput,
    },
};
</script>

<style scoped>
.tooltip {
    @apply invisible absolute;
}
.has-tooltip:hover .tooltip {
    @apply visible z-50;
}
</style>
